import * as React from "react";
import * as Yup from "yup";
import { useTl, useApiService, useCrudApi } from "../../../../hooks";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { SmallFormGenerator } from "../../../../components";
import {
  FieldGroup,
  FGTextInput,
  FGTextAreaInput,
  FGSelectInput,
} from "nsitools-react";
import { DocumentTemplateApi, DocumentTemplateDto } from "../../../../api";
import { useReferential } from "../../../../hooks/useReferential";

export interface IDocumentTemplateDetailPageProps {
  documentTemplateId: number;
  editMode: boolean;
}

export const DocumentTemplateDetailPage: React.FunctionComponent<IDocumentTemplateDetailPageProps> = ({
  documentTemplateId,
  editMode,
}) => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(DocumentTemplateApi);
  const { languages } = useGlobalData();

  const { data, loading, saveItem, saving, deleteItem, deleting } = useCrudApi(
    {
      getApiFn: (id = documentTemplateId) => api.getDocumentTemplate(id),
      saveApiFn: (d: DocumentTemplateDto) => api.saveDocumentTemplate(d),
      onSavedRoute: (d) =>
        `${ERoutes.documentTemplate}/${d.documentTemplateId}/detail/edit`,
      deleteApiFn: (d) => {},
    },
    [documentTemplateId]
  );

  const [papierDecoration, pdLoading] = useReferential(
    (c) => c.getPaperDecorations(),
    false,
    []
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({});
  }, []);

  return (
    data && (
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        onCancel={() => history.push(ERoutes.documentTemplate)}
        saving={saving}
        deleting={deleting}
        showDeleteButton={false}
        onDelete={deleteItem}
        validationSchema={FormSchema}
      >
        <FieldGroup>
          <FGTextInput
            name={`description`}
            label={t(ETLCodes.Description)}
            readonly
          />
          <FGTextInput name={`printer`} label={t(ETLCodes.Printer)} readonly />
          <FGSelectInput
            name={`paperDecoration`}
            label={t(ETLCodes.PaperDecoration)}
            items={papierDecoration}
            loading={pdLoading}
          />
        </FieldGroup>
        {data.documentContent.map((item, index) => {
          return (
            <FieldGroup
              key={index}
              fieldsetProps={{
                title: languages.find((c) => c.languageId === item.languageId)
                  ?.languageCode,
                collapsable: true,
              }}
            >
              <FGTextInput
                name={`documentContent[${index}].recipientInfo`}
                label={t(ETLCodes.RecipientInfo)}
              />
              <FGTextAreaInput
                name={`documentContent[${index}].content`}
                label={t(ETLCodes.Content)}
                rows={10}
              />
            </FieldGroup>
          );
        })}
      </SmallFormGenerator>
    )
  );
};
